import { notImplemented, mod97CheckSum } from "../utils/general-helper";
import { IRegionFunctions, ParsedAccount } from "./region-functions";

const regionFunctionsNO = (): IRegionFunctions => {
	const accounNrExpression = RegExp(/^(\d{11})$/);
	const basicIbanStructureRegEx = /^(?=.{15,34}$)[A-Z]{2}[A-Z0-9]+$/;
	const validPhoneNrExpression = RegExp(/^(\+47|2)\d{1,2}[- ]?\d{2}[- ]?\d{2}[- ]?\d{2}$/);
	const clearingNumberLength = 4;
	const accountNumberMaxLength = 11;

	const validPhoneNumber = (phoneNumber: string): boolean => validPhoneNrExpression.test(phoneNumber);

	const formatPhoneNumber = (_phoneNumber: string): string => {
		return notImplemented();
	};

	const validateAccountNumber = (accountNumber: string): boolean => {
		accountNumber = accountNumber.replace(/\D/g, "");
		return accounNrExpression.test(accountNumber);
	};

	const getBankAccountMeta = (_accountNrIncludingClearing?: string) => {
		return {
			clearingNumberLength,
			accountNumberMaxLength,
		};
	};

	const parseAccountNumber = (accountNrIncClearing: string): ParsedAccount => {
		const sanitizedAccountNr = accountNrIncClearing.replace(/\D/g, "");
		const clearingNr = sanitizedAccountNr.slice(0, clearingNumberLength);
		const accountNr = sanitizedAccountNr.slice(clearingNumberLength);
		return { clearingNumber: clearingNr, accountNumber: accountNr };
	};

	const formatAccountNumber = (clearingNumber: string, accountNr: string): string => {
		const accountNrIncClearing = (clearingNumber + accountNr).replace(/[^0-9*]/g, "");

		const clearingNr = accountNrIncClearing.slice(0, clearingNumberLength);
		const accountNumber = accountNrIncClearing.slice(clearingNumberLength);

		const parts = [clearingNr, accountNumber].filter((part) => part);

		return parts.join(" ");
	};

	const validateIban = (IBAN: string, allowedCountryCodes?: string): boolean => {
		if (IBAN.length < 1) return true;
		if (allowedCountryCodes && allowedCountryCodes !== "") {
			const ibanCountryCode = IBAN.substring(0, 2);
			if (!allowedCountryCodes.split(",").some((countryCode) => countryCode === ibanCountryCode))
				return false;
		}
		IBAN = IBAN.replace(/[\s]+/g, "").toUpperCase();
		if (!basicIbanStructureRegEx.test(IBAN)) return false;

		const rearrangedIban = IBAN.slice(4) + IBAN.slice(0, 4);
		const convertedIban = rearrangedIban.replace(/[A-Z]/g, (char) => (char.charCodeAt(0) - 55).toString());

		return mod97CheckSum(convertedIban);
	};

	return {
		validateAccountNumber,
		formatAccountNumber,
		validPhoneNumber,
		formatPhoneNumber,
		parseAccountNumber,
		validateIban,
		bankAccountMeta: getBankAccountMeta,
	};
};
export const NORegionFunctions = regionFunctionsNO();
